export class ValidationError extends Error {
  constructor(error) {
    super();

    this.message = error;
  }
}

export const translateErrorMessage = (key) => ({
}[key] || key);

export class ApiError extends Error {
  constructor(error) {
    super();

    this.error = error;
    this.message = translateErrorMessage(error);
  }
}

export class StripeError extends Error {
  constructor(code, message) {
    super();

    const retryMessages = [
      "card_declined",
      "expired_code",
      "incorrect_cvc",
      "processing_error",
    ];

    this.fatal = !retryMessages.includes(code);
    this.message = message;
  }
}